export default "__VITE_ASSET__h1jEArPd__"